import api from "./api";

export const removeFavorite = async (id?: number) => {
	const { data } = await api.delete(`products/favorite/${id}`);

	return data;
};

//disciplines
export const listFavoriteDisciplines = async (params?: any) => {
	const { data } = await api.get("products/favorite/discipline/", {
		params: params,
	});

	return data;
};

export const saveFavoriteDiscipline = async (id: number) => {
	const { data } = await api.post("products/favorite/ ", { discipline: id });

	return data;
};

//unities
export const listFavoriteUnities = async (params?: any) => {
	const { data } = await api.get("products/favorite/item/", {
		params: params,
	});

	return data;
};

export const saveFavoriteUnity = async (id: number) => {
	const { data } = await api.post("products/favorite/ ", { item: id });

	return data;
};

//themes
export const listFavoriteThemes = async (params?: any) => {
	const { data } = await api.get("products/favorite/theme/", {
		params: params,
	});

	return data;
};

export const saveFavoriteTheme = async (id: number) => {
	const { data } = await api.post("products/favorite/ ", { theme: id });

	return data;
};

//objects
export const listFavoriteObjects = async (params?: any) => {
	const { data } = await api.get("products/favorite/media/", {
		params: params,
	});

	return data;
};

export const saveFavoriteObject = async (id: number) => {
	const { data } = await api.post("products/favorite/ ", { media: id });

	return data;
};

//my links
export const listMyLinks = async (params?: any) => {
	const { data } = await api.get("products/links/", { params: params });

	return data;
};

export const listLinkLeaves = async (
	material_type: string,
	material_id: number
) => {
	const { data } = await api.get("products/links/leaf", {
		params: {
			material_type,
			material_id,
		},
	});

	return data;
};

export const changeStatusLink = async (
	linkId: number,
	userId: number,
	status: boolean,
	type: string
) => {
	let params = {
		is_active: status,
		remove: false,
		product_type: type,
	};

	const { data } = await api.post(
		`manager/profile/${userId}/link/${linkId}`,
		params
	);

	return data;
};

export const deleteLink = async (
	linkId: number,
	userId: number,
	status: boolean,
	type: string
) => {
	let params = {
		is_active: status,
		remove: true,
		product_type: type,
	};

	const { data } = await api.post(
		`manager/profile/${userId}/link/${linkId}`,
		params
	);

	return data;
};
